import React, { createContext, useContext, useState, useMemo } from 'react'

type LogoutContextType = {
  isLogoutComponentActive: boolean
  setLogoutComponentActive: (active: boolean) => void
}

const LogoutContext = createContext<LogoutContextType>({
  isLogoutComponentActive: false,
  setLogoutComponentActive: () => {},
})

export const useLogoutContext = () => useContext(LogoutContext)

export const LogoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLogoutComponentActive, setLogoutComponentActive] = useState(false)

  const value = useMemo(() => ({ isLogoutComponentActive, setLogoutComponentActive }), [isLogoutComponentActive])

  return <LogoutContext.Provider value={value}>{children}</LogoutContext.Provider>
}
